import React, { useState, useEffect } from 'react';
import './ImageSlider.scss'; // Make sure to create this CSS file

function ImageSlider({ images }) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fadeProp, setFadeProp] = useState('fade-in');

  const TIMEOUT = 3000;      // Time between image changes (in milliseconds)
  const FADE_DURATION = 1000; // Duration of fade transition (in milliseconds)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFadeProp('fade-out');

      setTimeout(() => {
        setCurrentImageIndex((currentImageIndex + 1) % images.length);
        setFadeProp('fade-in');
      }, FADE_DURATION); // Wait for fade-out to complete before changing image
    }, TIMEOUT);

    return () => clearTimeout(timeout);
  }, [currentImageIndex, images.length]);

  return (
    <div className="image-slider">
      <img
        src={images[currentImageIndex]}
        alt="slideshow"
        className={fadeProp}
      />
    </div>
  );
}

export default ImageSlider;
